module.exports = __webpack_public_path__ + "img/goblin_5.f855ecbf.png";